import { defineAsyncComponent } from 'vue'
export default {
  custom: defineAsyncComponent(() => import("/tmp/tmphel3alyy/layouts/custom.vue").then(m => m.default || m))
}